








import { UserProfile } from "@api/models/UserProfile";
import { Vue, Component, Prop } from "vue-property-decorator";
import TitleTooltip from "./TitleTooltip.vue"

@Component({ components: { TitleTooltip }})

export default class TicketTitle extends Vue {
    @Prop() title: string;
    @Prop() userProfile: UserProfile | undefined;
}

